module.exports = __webpack_public_path__ + "img/57.4800c73a.jpg";